import React from 'react';

import { RouteComponentProps } from 'react-router';
import { Portal } from '@bringg-frontend/bringg-web-infra';

import { View } from 'bringg-web/features/monitoring/shared/types';
import Monitoring from 'bringg-web/features/monitoring/monitoring';

interface Props {
	view: View;
}

export const MonitoringContainer = ({ view }: Props) => {
	return <Monitoring view={view} />;
};

export const MonitoringPortal = React.memo<RouteComponentProps & { view: View }>(
	function MonitoringPortal(props) {
		return <Portal element={<MonitoringContainer view={props.view} />} nodeId="monitoring-portal" />;
	},
	(prev, next) => {
		// Don't rerender on search params changes as this would cause the filtering to flicker
		return prev.location.pathname === next.location.pathname;
	}
);
